/**
 * jQuery.autoload - Auto load content on scroll
 * Copyright (c) 2011, 2020, 2021, 2022 Hiltonian Media Ltd, www.hiltonian.com
 * Use not permitted without written permission
 * Date: 21/06/2022
 * @author Richard Rutherford Hilton
 * @version 2.2.0
 */
 (function($){
	$.fn.autoload = function(options) {

		// Quit if IntersectionObserver is not available
		if (!('IntersectionObserver' in window)) return;

		var settings = {
			paginator: 'ul.selector',
			nextLink: 'ul.selector .next a',
			nextContent: null, 
			appendTo: null, // if null, append to selected element
			loading: '<p class="autoload-loading">Loading</p>',
			more: '<p class="autoload-more"><a href="#">Load More...</a></p>',
			container: null, // if null, use <body>
			offset: 400,
			sequence: [true], // Each element in the array indicates whether the load should be automatic or manual, e.g. [true, true, true, false] for three autoloads followed by a manual load (then repeats)
			onload: function () {},
			clearCache: 3
		}
		
		if (options) $.extend(settings, options);

		// Clear old values from session storage
		var keys = [];
		for (key in sessionStorage) {
			var matches = key.match(/autoload_cache_([0-9]+)(.+)/);
			if (!matches) continue;
			keys.push({
				t: matches[1],
				r: matches[2],
			});
		}
		keys.sort(function(a, b) { return parseInt(a.t)-parseInt(b.r); }).reverse()
		$.each(keys, function(i, v) {
			if (i < keys.length - 3) {
				sessionStorage.removeItem('autoload_cache_' + v.t + v.r);
			}
		});
		
		return this.each(function() {
			var content = $(this);
			var container = settings.container ? $(settings.container) : $('body');
			var appendTo = $(settings.appendTo ? settings.appendTo : content);
			var pages_loaded = 0; // Keeps track of how many *extra* pages have been autoloaded
			var key = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
			var observedElement = null;
			var firstPageCache = appendTo.html();

			const observer = new IntersectionObserver(entries => {
				if (entries[0].isIntersecting) {
					loadNext();
					observer.unobserve(entries[0].target);
				}
			});
			
			var getNextLink = function(container) {
				var next = $(settings.nextLink, container).attr('href');
				if (next && next.length > 0 && next != '#') {
					return next;
				} else {
					return false;
				}
			}
			var next = getNextLink(container);
			
			var loading = $(settings.loading);
			var more = $(settings.more);
			
			$(settings.paginator, container).hide();
			if (next) content.after(loading).after(more);
			var offset;

			var setOffset = function() {
				offset = (content.offset().top + content.height()) - settings.offset;
			}

			var nextIsAuto = function() {
				return !$.isArray(settings.sequence) 
					|| settings.sequence.length == 0 
					|| settings.sequence[pages_loaded % settings.sequence.length];
			}

			var loadNext = function() {
				if (next) {
					$.get(next, function(newContent) {
						next = getNextLink(newContent);
						updateContent(getContentFromHTML(newContent), false);
					}).fail(function() {
						switchAutoOff();
					});
				} else {
					switchAutoOff();
				}
			}

			more.click(function() {
				loadNext();
				return false;
			});

			var switchAutoOff = function() {
				if (observedElement) observer.unobserve(observedElement);
				loading.hide();
				if (next) {
					more.show().attr('href', next);
				} else {
					more.hide();
				}
			}

			var switchAutoOn = function() {
				setOffset();
				more.hide();
				if (next) {
					loading.show();
					observedElement = appendTo.children(':visible').last()[0];
					if (observedElement) observer.observe(observedElement);
				} else {
					loading.hide();
				}
			}

			var getContentFromHTML = function(html) {
				return $(settings.nextContent, html).children().toArray().reduce(function(result, element) { return result + element.outerHTML}, '');
			}

			var updateContent = function(newContent, init) {
				// Update the content
				if (init) {
					appendTo.empty();
				}
				
				var tempContainer = document.createElement('div');
				tempContainer.innerHTML = newContent;
				var newChildren = $(tempContainer).children();
				
				// Make sure users can (smoothly) return to the page
				if (!init && window.history && typeof(Storage) !== "undefined") {
					pages_loaded++;
					history.replaceState({
						key: key,
						next: next,
						pages: pages_loaded
					}, '');
					try {
						var oldCacheContent = sessionStorage.getItem('autoload_cache_' + history.state.key) || firstPageCache;
						sessionStorage.setItem('autoload_cache_' + key, oldCacheContent + newContent);
					} catch (e) {
						// Session storage full
					}
				}

				appendTo.append(newChildren);
				settings.onload(newChildren, init);

				if (nextIsAuto()) {
					switchAutoOn();
				} else {
					switchAutoOff();
				}
			};

			// Deal with back/forward button clicks
			if (window.history && history.state && history.state.key && typeof(Storage) !== "undefined") {
				var cachedContent = sessionStorage.getItem('autoload_cache_' + history.state.key);
				if (cachedContent && cachedContent.length) {
					key = history.state.key;
					next = history.state.next;
					pages_loaded = history.state.pages || 0;
					if (pages_loaded > 0) updateContent(cachedContent, true);
				}
			}

			if (nextIsAuto()) {
				switchAutoOn();
			} else {
				switchAutoOff();
			}
		});
	};
})(jQuery);